import { render, staticRenderFns } from "./CheckListTag.vue?vue&type=template&id=51616c00"
import script from "./CheckListTag.vue?vue&type=script&lang=js"
export * from "./CheckListTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports